import { useState } from "react";
import styles from "./MentionsPage.module.scss";

function MentionsPage() {
  const [activeTab, setActiveTab] = useState("legal");

  return (
    <div className={styles.pageWrapper}>
      <div className={styles.pageHeader}>
        <h1>Mentions légales & Politique de confidentialité</h1>
        <p className={styles.subtitle}>Éclat de Beauté</p>
      </div>

      <div className={styles.contentWrapper}>
        <div className={styles.tabs}>
          <button
            type="button"
            className={
              activeTab === "legal" ? styles.tabBtnActive : styles.tabBtn
            }
            onClick={() => setActiveTab("legal")}
          >
            Mentions légales
          </button>
          <button
            type="button"
            className={
              activeTab === "privacy" ? styles.tabBtnActive : styles.tabBtn
            }
            onClick={() => setActiveTab("privacy")}
          >
            Politique de confidentialité
          </button>
        </div>

        <div className={styles.card}>
          {activeTab === "legal" && (
            <div id="legal">
              <p>
                Conformément aux dispositions de l'article 1-1 de la loi n°
                2004-575 du 21 juin 2004 pour la confiance dans l'économie
                numérique (LCEN), il est précisé aux utilisateurs de ce site
                l'identité des différents intervenants dans le cadre de sa
                réalisation et de son suivi.
              </p>

              <h2>Éditeur du site</h2>
              <ul>
                <li>
                  <strong>Nom / Dénomination : </strong>
                  Eclat de beauté
                </li>
                <li>
                  <strong>Statut juridique : </strong>
                  Auto-entrepreneur
                </li>
                <li>
                  <strong>SIRET : </strong>
                  534 836 283 00034
                </li>
                <li>
                  <strong>Adresse : </strong>3 chemin des Noyers, 59990 Saultain
                </li>
                <li>
                  <strong>Téléphone : </strong>
                  <a href="tel:+33604197561">06 04 19 75 61</a>
                </li>
                <li>
                  <strong>Email : </strong>
                  <a href="mailto:contact@éclatdebeauté.fr">
                    contact@éclatdebeauté.fr
                  </a>
                </li>
              </ul>

              <h2>Hébergement</h2>
              <ul>
                <li>
                  <strong>Hébergeur : </strong>
                  OVH
                </li>
                <li>
                  <strong>Adresse de l'hébergeur : </strong>2 rue Kellermann,
                  59100 Roubaix
                </li>
                <li>
                  <strong>Contact : </strong>
                  <a
                    href="https://www.ovhcloud.com"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    www.ovhcloud.com
                  </a>
                </li>
              </ul>

              <h2>Conception et développement</h2>
              <p>
                Site conçu et développé par{" "}
                <a
                  href="https://sgwebcreation.fr"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  SG Web Creation
                </a>
              </p>

              <h2>Propriété intellectuelle</h2>
              <p>
                L'ensemble des contenus présents sur ce site (textes, images,
                photographies, logos, identité visuelle) est la propriété
                exclusive de l'éditeur, sauf mention contraire. Toute
                reproduction, représentation, modification ou adaptation, totale
                ou partielle, de ces éléments, par quelque procédé que ce soit,
                est strictement interdite sans autorisation écrite préalable.
              </p>

              <h2>Limitation de responsabilité</h2>
              <p>
                L'éditeur s'efforce d'assurer l'exactitude des informations
                diffusées sur ce site, mais ne saurait être tenu responsable des
                erreurs, omissions ou de l'indisponibilité des informations et
                services proposés.
              </p>

              <h2>Droit applicable</h2>
              <p>
                Les présentes mentions légales sont soumises au droit français.
                En cas de litige et à défaut de résolution amiable, les
                tribunaux français seront seuls compétents.
              </p>

              <div className={styles.lastUpdate}>
                Dernière mise à jour : 28/08/2026
              </div>
            </div>
          )}

          {activeTab === "privacy" && (
            <div id="privacy">
              <p>
                Cette politique de confidentialité décrit comment vos données
                personnelles sont collectées, utilisées et protégées lorsque
                vous utilisez ce site, conformément au Règlement Général sur la
                Protection des Données (RGPD) et à la loi Informatique et
                Libertés.
              </p>

              <h2>Responsable du traitement</h2>
              <p>
                Le responsable du traitement des données collectées sur ce site
                est l'entreprise Eclat de beauté, joignable à l'adresse{" "}
                <a href="mailto:contact@éclatdebeauté.fr">
                  contact@éclatdebeauté.fr
                </a>
                .
              </p>

              <h2>Données collectées</h2>
              <p>
                Lorsque vous utilisez le formulaire de prise de rendez-vous, les
                données suivantes sont collectées : nom, prénom, adresse, numéro
                de téléphone, adresse email, ainsi que les informations
                relatives aux prestations réservées (type, date, créneau
                horaire, tarif).
              </p>
              <p>
                Lorsque vous utilisez le formulaire de contact, seules les
                données nécessaires à la réponse à votre demande sont collectées
                : nom, prénom, adresse email et message.
              </p>

              <h2>Finalités et bases légales</h2>
              <table className={styles.tableSummary}>
                <tbody>
                  <tr>
                    <th>Finalité</th>
                    <th>Base légale</th>
                  </tr>
                  <tr>
                    <td>
                      Gestion et suivi des rendez-vous (prise, confirmation,
                      modification, annulation)
                    </td>
                    <td>
                      Exécution de mesures précontractuelles / contractuelles
                      (art. 6.1.b RGPD)
                    </td>
                  </tr>
                  <tr>
                    <td>
                      Gestion de la relation client et historique des
                      prestations
                    </td>
                    <td>Exécution du contrat (art. 6.1.b RGPD)</td>
                  </tr>
                  <tr>
                    <td>
                      Envoi de communications liées au rendez-vous (email de
                      confirmation)
                    </td>
                    <td>Exécution du contrat (art. 6.1.b RGPD)</td>
                  </tr>
                  <tr>
                    <td>
                      Réponse aux demandes envoyées via le formulaire de contact
                    </td>
                    <td>
                      Intérêt légitime à répondre aux demandes des visiteurs
                      (art. 6.1.f RGPD)
                    </td>
                  </tr>
                  <tr>
                    <td>
                      Établissement de statistiques internes sur l'activité
                      (fréquentation, chiffre d'affaires, popularité des
                      prestations)
                    </td>
                    <td>
                      Intérêt légitime du responsable de traitement (art. 6.1.f
                      RGPD)
                    </td>
                  </tr>
                </tbody>
              </table>

              <h2>Caractère obligatoire de la collecte</h2>
              <p>
                Les champs identifiés comme obligatoires dans les formulaires
                sont nécessaires au traitement de votre demande. À défaut de
                renseignement de ces champs, votre demande ne pourra pas être
                traitée.
              </p>

              <h2>Destinataires des données</h2>
              <p>
                Les données collectées sont destinées exclusivement à
                l'entreprise Eclat de beauté. Aucune donnée n'est cédée, louée
                ou vendue à des tiers à des fins commerciales.
              </p>

              <h2>Durée de conservation</h2>
              <p>
                Les données issues du formulaire de rendez-vous sont conservées
                pendant 3 ans à compter du dernier contact ou rendez-vous. Les
                messages issus du formulaire de contact sont conservés le temps
                nécessaire au traitement de la demande, puis supprimés.
              </p>

              <h2>Sécurité des données</h2>
              <p>
                Des mesures techniques et organisationnelles appropriées sont
                mises en œuvre pour assurer la sécurité et la confidentialité
                des données (hébergement sécurisé, connexion chiffrée HTTPS,
                accès restreint à l'interface d'administration).
              </p>

              <h2>Cookies</h2>
              <p>
                Ce site utilise uniquement des cookies techniques strictement
                nécessaires à son fonctionnement (par exemple pour maintenir la
                session de connexion à l'espace d'administration). Ces cookies
                ne nécessitent pas de consentement préalable.
              </p>

              <h2>Vos droits</h2>
              <p>
                Conformément au RGPD, vous disposez des droits suivants sur vos
                données :
              </p>
              <ul>
                <li>
                  Droit d'accès : obtenir la confirmation que vos données sont
                  traitées et en obtenir une copie ;
                </li>
                <li>
                  Droit de rectification : faire corriger des données inexactes
                  ou incomplètes ;
                </li>
                <li>
                  Droit à l'effacement : demander la suppression de vos données
                  dans les conditions prévues par la loi ;
                </li>
                <li>
                  Droit d'opposition : vous opposer, pour des motifs légitimes,
                  au traitement de vos données ;
                </li>
                <li>Droit à la limitation du traitement.</li>
              </ul>
              <p>
                Pour exercer ces droits, contactez Virginie BALLINI à l'adresse
                email{" "}
                <a href="mailto:contact@éclatdebeauté.fr">
                  contact@éclatdebeauté.fr
                </a>
                .
              </p>

              <p>
                Si vous estimez, après nous avoir contactés, que vos droits ne
                sont pas respectés, vous pouvez adresser une réclamation à la{" "}
                <a
                  href="https://www.cnil.fr"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Commission Nationale de l'Informatique et des Libertés (CNIL)
                </a>
                .
              </p>

              <div className={styles.lastUpdate}>
                Dernière mise à jour : 28/08/2026
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default MentionsPage;
